import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"

import Select from "./elements/Select"

export default function SortBy() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    useEffect(() => {
        const handleKeydown = (event) => {
            if(event.key === "Escape" || event.key === "Enter") {
                setSortOpen(false);
            }
        }
        if(sortOpen) {
            window.document.addEventListener('keydown', handleKeydown)
        }
        return () => window.document.removeEventListener('keydown', handleKeydown)
    }, [ sortOpen ])
    
    useEffect(() => { // close dropdown when clicking outside
        const handleClick = (event) => {
            if(
                dropdownRef.current && toggleRef.current &&
                !dropdownRef.current.contains(event.target) && 
                !toggleRef.current.contains(event.target)
            ) {
                setSortOpen(false);
            };
        };

        if(sortOpen) {
            window.document.addEventListener('click', handleClick);
        };
        return () => window.document.removeEventListener('click', handleClick);
    }, [ sortOpen ]);

    const handleOptionClick = (event) => {
        const optionId = event.target.closest('.ns-sort-option').getAttribute('data-id');
        setSort(optionId);
        setSortOpen(false);
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <div class="border-t-border-primary">
            <div class="flow-root group/filter-dropdown">
                <div class="flex w-full items-center justify-between">
                    <div class="ns-sort flex flex-col gap-2xs w-full group">
                        <div class="group peer relative w-full" open={sortOpen}>
                            <button 
                                type="button"
                                class="text-left block bg-c-form-bg w-full border appearance-none text-t-foreground disabled:text-t-border px-5 h-button-height body-16 bg-transparent border-t-border focus:outline-none focus:ring-0 focus:border-t-foreground peer group-[[error]]:ring-u-error group-[[error]]:border-[transparent] group-[[error]]:ring-2 focus-visible:ring-2 focus-visible:ring-u-focus"
                                role="combobox"
                                aria-haspopup="listbox"
                                aria-controls="ns-sort__dropdown"
                                aria-expanded={sortOpen}
                                onClick={toggleSort}
                                ref={toggleRef}
                            >
                                <h6 id="ns-sort__header" class="body-14 block truncate pr-sm">Sort</h6>
                                <div class="absolute inset-y-0 flex items-center size-3 pointer-events-none end-sm-forms-padding lg:end-sm-forms-padding text-t-foreground group-[[error]]:text-u-error h-button-height">
                                    <svg fill="none" id="icon-select-arrow" viewBox="0 0 11 10" role="presentation" focusable="false" aria-hidden="true">
                                        <path stroke="currentColor" d="m9.917 2.917-4.583 4.01L.75 2.917"></path>
                                    </svg>
                                </div>
                            </button>
                            <div
                                class="custom-select__dropdown py-[5px] min-w-[220px] shadow-[0_0_8px_0_rgba(0,0,0,0.15)] lg:min-w-[262px] max-h-[50vh] bg-t-brand-primary-contrast overflow-y-scroll overflow-x-clip scrollbar-thin scrollbar-track-[transparent] scrollbar-thumb-p-neutral absolute z-20 hidden top-full right-0 w-full border-[#e2e2e2] border group-[[open]]:grid translate-y-4 opacity-0 transition-[opacity,display,transform] [transition-behavior:allow-discrete] motion-reduce:transition-none duration-300 group-[[open]]:translate-y-0 group-[[open]]:opacity-100 !motion-reduce:group-[[open]]:transition-none"
                                role="listbox"
                            >
                                {sortOptions.map((option, i) => (
                                    <button
                                        key={option.id}
                                        type="button"
                                        role="option"
                                        class="ns-sort-option relative py-[12.5px] lg:py-2.5 pl-10 pr-4 lg:pb-2.5 text-left [&amp;[selected]]:after:opacity-100 after:-translate-y-1/2 after:opacity-0 after:absolute after:top-1/2 after:left-[19px] after:content-[''] after:rounded-full after:w-2 after:h-2 [&amp;[selected]]:after:bg-t-foreground-secondary before:content-[''] before:rounded-full before:border-bg-t-border before:left-[15px] before:top-1/2 before:-translate-y-1/2 before:w-4 before:h-4 before:border before:absolute [&amp;[selected]]:text-t-foreground-secondary"
                                        data-id={option.id}
                                        onClick={handleOptionClick}
                                        aria-selected={(activeSort === option.id)}
                                        selected={(activeSort === option.id)}
                                    >
                                        <span class="group-focus:ring-u-focus body-14 block group-focus-visible:ring-2">
                                            {option.value.name}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}